/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument } from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument';
import {
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSON,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSONTyped,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSON,
} from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument';

/**
 * 
 * @export
 * @interface MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner
 */
export interface MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner {
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner
     */
    s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner
     */
    generated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner
     */
    previous_generated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner
     */
    type?: MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner
     */
    instance_id?: string;
    /**
     * 
     * @type {CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument}
     * @memberof MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner
     */
    external_ehr_document?: CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument;
}


/**
 * @export
 */
export const MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum = {
    SummaryReport: 'summary_report',
    RulesReport: 'rules_report',
    DataPullsReport: 'data_pulls_report',
    SOffenderReport: 's_offender_report',
    MedicationsReport: 'medications_report',
    InsuranceEligibilityCheck: 'insurance_eligibility_check',
    AdvancedAiInsuranceCheck: 'advanced_ai_insurance_check',
    PalAuthSubmissionPackage: 'pal_auth_submission_package',
    PdpmReport: 'pdpm_report'
} as const;
export type MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum = typeof MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum[keyof typeof MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum];


/**
 * Check if a given object implements the MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner interface.
 */
export function instanceOfMatrixCarePatientDetailsDocumentsGeneratedDocumentsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerFromJSON(json: any): MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner {
    return MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        's3_key': !exists(json, 's3_key') ? undefined : json['s3_key'],
        'generated_at': !exists(json, 'generated_at') ? undefined : json['generated_at'],
        'previous_generated_at': !exists(json, 'previous_generated_at') ? undefined : json['previous_generated_at'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'instance_id': !exists(json, 'instance_id') ? undefined : json['instance_id'],
        'external_ehr_document': !exists(json, 'external_ehr_document') ? undefined : CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSON(json['external_ehr_document']),
    };
}

export function MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerToJSON(value?: MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'name': value.name,
        's3_key': value.s3_key,
        'generated_at': value.generated_at,
        'previous_generated_at': value.previous_generated_at,
        'type': value.type,
        'instance_id': value.instance_id,
        'external_ehr_document': CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSON(value.external_ehr_document),
    };
}

